import Sentry from '@/services/sentry'
import { getWithExpiry, setWithExpiry, DAY_IN_MILLISECONDS } from '@/utils/local.storage.expiry'

const KEY_PREFIX = 'create-slide-popup-seen-new-slide-types'
const EXPIRY_TTL = DAY_IN_MILLISECONDS * 365

const getStorageKey = (userId) => `${KEY_PREFIX}-${userId}`

export const getSeenNewSlideTypes = (userId) => {
  if (!userId) return []
  try {
    const key = getStorageKey(userId)
    const stored = getWithExpiry(key)
    if (Array.isArray(stored)) {
      return stored
    }
    return []
  } catch (error) {
    // Fail silently — non-critical UI hint
    return []
  }
}

export const addSeenNewSlideType = (userId, slideName) => {
  if (!userId || !slideName) return getSeenNewSlideTypes(userId)
  try {
    const key = getStorageKey(userId)
    const currentList = getSeenNewSlideTypes(userId)

    if (currentList.includes(slideName)) {
      return currentList
    }

    const updatedList = [...currentList, slideName]
    setWithExpiry(key, updatedList, EXPIRY_TTL)
    return updatedList
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        feature: 'create-slide-popup-seen-new-slide-types',
        context: 'addSeenNewSlideType',
      },
    })
    return getSeenNewSlideTypes(userId)
  }
}
